import { siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 pb-10 md:py-0 bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-96 h-96 rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-20 left-0 w-80 h-80 rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start text-left">
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                <i className="ri-fire-line text-sm"></i>每日更新
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                <i className="ri-flashlight-line text-sm"></i>全网热播
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                <i className="ri-vip-crown-line text-sm"></i>原创精选
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              海角网
              <span className="block text-primary-500">千万原创视频平台</span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-heading">
              {siteInfo.slogan}
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap gap-6 mt-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="#media"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索话题
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] lg:aspect-[5/4] overflow-hidden rounded-2xl">
              <img
                src={siteInfo.heroImage}
                alt="海角网 - 千万原创视频平台主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}